import React, { memo } from "react";
import {
	Row,
	UseRowStateInstanceProps,
	UseTableInstanceProps,
} from "react-table";

import { TableRow } from "./row";
import { NoRecords } from "./noRecords";

import styles from "./table.module.scss";

const defaultProps = {
	rows: [],
};
type Props = Pick<
	UseTableInstanceProps<any>,
	"getTableBodyProps" | "prepareRow"
> &
	Pick<UseRowStateInstanceProps<any>, "setRowState"> & {
		rows: Array<Row>;
		onRowClick?: (row: { [key: string]: any }) => any;
		handleRowSubmit?: ({
			values,
			row,
			setRowState,
		}: {
			values: { [key: string]: any };
			row: { [key: string]: any };
			setRowState: any;
		}) => any;
	};

// Each row is rerendered on change
// because of 'row' being passed
// but 'row' is  currently kept to provide more extensibility
const TableBody = ({
	getTableBodyProps,
	prepareRow,
	rows = defaultProps.rows,
	setRowState,
	onRowClick,
	handleRowSubmit,
}: Props) => (
	<div {...getTableBodyProps()} className={styles.body}>
		{rows.map((row, i) => {
			prepareRow(row);
			return (
				<TableRow
					onRowClick={onRowClick}
					row={row}
					key={row.id}
					setRowState={setRowState}
					handleRowSubmit={handleRowSubmit}
				/>
			);
		})}
		{!rows.length && <NoRecords />}
	</div>
);

const Component = memo(TableBody); // This memo might cause issue with editable table.
export { Component as TableBody }; // TODO: Remove it\comment if works properly
